import React, { useCallback, useEffect, useReducer, useRef, useState } from 'react';
import { useLocation } from 'react-router';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { CSSTransition } from 'react-transition-group';
import classNames from 'classnames';
import api from '../../apiSingleton';
import Spinner from '../Spinner';
import { useModal } from '../../utils/useModal';
import ClosePopupIcon from '../../assets/icon/ClosePopupIcon';
import history from '../../history';
import style from '../PopupLogIn/PopupLogIn.module.scss';

function PopupResetPassword() {
    const password = useRef();
    const [ loading, setLoading ] = useState(false);
    const popupBody = useRef(null);
    const popup = useRef();
    const { dismiss } = useModal();
    const [ initPopup, setInitPopup ] = useState(false);
    const [ change, setChange ] = useState(false);
    const [ error, setError ] = useState('');
    const location = useLocation();

    const [ event, updateEvent ] = useReducer(
        (prev, next) => ({ ...prev, ...next }),
        { password: '' }
    );

    useEffect(() => {
        document.addEventListener('click', closeModal);
        setInitPopup(true);
        disableBodyScroll(document.body);

        return () => document.removeEventListener('click', closeModal);
    }, []);

    const closeModal = useCallback(({ target }) => {
        if (popupBody?.current && !popupBody?.current.contains(target)) {
            enableBodyScroll(document.body);
            clearAllBodyScrollLocks();
            dismiss();
            history.replace('/');
        }
    }, [ popupBody ]);


    const validatePassword = useCallback((pass) => {
        return pass.length >= 3;
    }, []);

    const closeBtn = useCallback(() => {
        dismiss();
        enableBodyScroll(document.body);
        history.replace('/');
    }, [ popupBody ]);

    const requestForm = useCallback(async (e) => {
        e.preventDefault();

        if (!validatePassword(event.password)) {
            setChange(true);

            return;
        }

        if (change) setChange(false);

        setLoading(true);

        try {
            await api.authenticate.resetPassword({ ...event, token: location?.query?.token });
            setLoading(false);
            closeBtn();
        } catch (errors) {
            setError(errors?.message);
            setLoading(false);
        }
    }, [ event, closeBtn, location?.query?.token ]);

    const changeHandle = useCallback(({ target })  => {
        setError('');
        setChange(false);
        updateEvent({ [target.name]: target.value });
    }, []);

    return (
        <>
            <CSSTransition
                timeout={300}
                in={initPopup}
                unmountOnExit
                classNames='item'
                mode={'out-in'}
            >
                <section className={style['popup-login']}  ref={popup}>
                    <div className={style['popup-login__wrapper']} ref={popupBody}>
                        <button className={style['popup-login__close']} onClick={closeBtn}>
                            <ClosePopupIcon />
                        </button>

                        { loading &&  <Spinner /> }
                        <h2>Відновлення паролю</h2>

                        <form onSubmit={requestForm}>
                            <label>
                                <input
                                    ref={password}
                                    name={'password'}
                                    type='password'
                                    placeholder={'Введіть новий пароль'}
                                    onChange={changeHandle}
                                />
                                {
                                    (change && !validatePassword(event.password)) && <span>Enter correct password</span>
                                }
                                {
                                    error?.length > 0 && <span>{error}</span>
                                }
                            </label>
                            <button disabled={error?.length > 0} className={classNames({ [style.error]: error?.length > 0 })}>
                                Відновити пароль
                            </button>
                        </form>
                    </div>
                </section>
            </CSSTransition>
        </>
    );
}

export default React.memo(PopupResetPassword);
